<template lang="pug">
  .header(:class="{ zero: !recentChats.length }")
    v-layout.wrapper
      Logo(serviceName="messenger", :logoSize="35", :fontSize="20")
      v-tabs(
        slot="extension",
        v-model="tab",
        height="80px",
        color="transparent")
        v-tabs-slider
        v-tab(@click="chatFilter = 0")
          span {{ $t('menu.allConversations') }}
        v-tab(v-if="devMode", @click="chatFilter = 4")
          span {{ $t('menu.people') }}
        v-tab(v-if="devMode", @click="chatFilter = 1")
          span {{ $t('menu.groups') }}
      DevMenu(v-if="devMode")
      v-layout.actions(justify-end, align-center)
        v-flex.profile
          a(:href="profileLink")
            .avatar(
              v-if="avatar_url",
              :style="{ 'background-image': 'url(' + avatarUrlWithResize(avatar_url, '60x60') + ')' }",
              :classname="getAvatarClass(first_name, last_name)")
            AvatarPlaceholder.avatar(v-else, :fullName="`${first_name.charAt(0)} ${last_name.charAt(0)}`")
          v-menu(
            v-model="profileMenu",
            right,
            bottom,
            nudge-bottom="35",
            :close-on-content-click="false")
            template(v-slot:activator="{ on }")
              .menu_activator.mobile(v-on="on", :class="{ has_unread: unreadMessagesTotal }")
                .avatar.mobile(
                  v-if="avatar_url",
                  :style="{ 'background-image': 'url(' + avatarUrlWithResize(avatar_url, '60x60') + ')' }",
                  :classname="getAvatarClass(first_name, last_name)")
                AvatarPlaceholder.avatar(v-else, :fullName="`${first_name.charAt(0)} ${last_name.charAt(0)}`")
            .profile_menu
              p #[a(:href="profileLink") {{ $t('menu.kickIdProfile') }}]
              p {{ $t('menu.messages') }} #[span(v-if="unreadMessagesTotal") {{ unreadMessagesTotalStr }}]
              //- p {{ $t('menu.notifications') }} #[span(v-if="unreadNotificationsTotal") {{ notificationsTotalStr }}]
              p(@click="logout") {{ $t('actions.logOut') }}
        //- v-flex.counter
        //-   SvgBell
        //-   span(v-if="unreadNotificationsTotal") {{ notificationsTotalStr }}
        v-flex.counter
          SvgMsgBubble
          span(v-if="unreadMessagesTotal") {{ unreadMessagesTotalStr }}
        v-flex.nav
          NavigationMenu(:services="services")
        v-flex.logout
          span(@click="logout")
            SvgLogout
</template>

<script>
import { mapState } from 'vuex';

import AvatarPlaceholder from '@/components/AvatarPlaceholder';
import Logo from '@/components/Logo';
import NavigationMenu from '@/components/ServicesNavigationMenu';
import SvgBell from '@/components/svg/SvgBell';
import SvgMsgBubble from '@/components/svg/SvgDoubleBubble';
import SvgLogout from '@/components/svg/SvgLogout';
import DevMenu from '@/components/DevMenu';

import socket from '@/socket';
import { SET_ACTIVE_CHAT, RESET_RECENT_CHATS } from '@/store/modules/chats/types';
import { avatarUrlWithResize, getAvatarClass } from '@/utils';
import CONSTANTS from '@/constants';

export default {
  components: {
    AvatarPlaceholder,
    Logo,
    NavigationMenu,
    SvgBell,
    SvgMsgBubble,
    SvgLogout,
    DevMenu
  },
  data() {
    return {
      avatarUrlWithResize,
      getAvatarClass,
      chatFilter: 0,
      unreadNotificationsTotal: 0,
      unreadMessagesTotal: 0,
      loggingOut: false,
      services: CONSTANTS.SERVICES_MENU.filter(i => i.visible),
      tab: null,
      profileMenu: false
    };
  },
  computed: {
    ...mapState('user', [
      'avatar_url',
      'first_name',
      'last_name'
    ]),
    ...mapState('chats', [
      'recentChats'
    ]),
    ...mapState('develop', {
      devMode: 'active'
    }),
    profileLink() {
      const session = localStorage.getItem('session_group_id');

      if (session) return process.env.VUE_APP_PROFILE.concat(`?session=${session}`);

      return process.env.VUE_APP_PROFILE;
    },
    unreadMessagesTotalStr() {
      if (this.unreadMessagesTotal === 1000) return '1K';

      if (this.unreadMessagesTotal > 1000) {
        const str = this.unreadMessagesTotal.toString();

        return `${str.charAt(0)}K+`;
      }

      return this.unreadMessagesTotal;
    },
    notificationsTotalStr() {
      if (this.unreadNotificationsTotal === 1000) return '1K';

      if (this.unreadNotificationsTotal > 1000) {
        const str = this.unreadNotificationsTotal.toString();

        return `${str.charAt(0)}K+`;
      }

      return this.unreadNotificationsTotal;
    }
  },
  watch: {
    chatFilter(val) {
      if (this.activeChat && val && this.activeChat.type_id !== val) {
        this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, null);
      }

      this.$store.commit(`chats/${RESET_RECENT_CHATS}`);
      this.$emit('requestChatsNextPage', val);
    }
  },
  methods: {
    logout() {
      const session = localStorage.getItem('session_group_id');

      if (this.loggingOut || !session) return;

      this.loggingOut = true;

      socket.logout(session);
    }
  },
  mounted() {
    this.$eventHub.$on('notificationCountUpdate', count => { this.unreadNotificationsTotal = count; });
    this.$eventHub.$on('messageCountUpdate', count => { this.unreadMessagesTotal = count; });
  },
  beforeDestroy() {
    this.$eventHub.$off('notificationCountUpdate');
    this.$eventHub.$off('messageCountUpdate');
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .header {
    position: sticky;

    &::before {
      height: 2px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background: $light-theme-line;
      content: '';
    }

    &.zero {
      padding-top: 20px;

      .v-tabs { display: none; }

      &::before { height: 0; }
    }

    .mobile { display: none; }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: auto;
      max-width: 1080px;

      @media screen and (max-width: 1024px) {
        flex-wrap: wrap;
        padding-top: 20px;
        max-width: 100%;

        .v-tabs { order: 3; }
        .actions { order: 2; }
      }
    }

    .actions {
      a { text-decoration: none !important; }

      .avatar {
        background-color: $white;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 15px;
        height: 30px !important;
        transition: all .2s $easing;
        width: 30px !important;
        min-width: 30px !important;

        ::v-deep span { font-size: 13px !important; }

        &:hover {
          box-shadow: 1px 2px 4px $light-theme-22-text;
          transform: scale(1.2);
        }
      }

      & > div {
        flex-grow: 0;
        margin-left: 25px;
        line-height: 1;
      }

      svg {
        width: 20px;
        height: 20px;
      }

      .counter {
        position: relative;

        svg { position: relative; }

        span {
          display: inline-block;
          position: absolute;
          top: -5px;
          right: -5px;
          font-size: 8px;
          background: $error-color;
          line-height: normal;
          font-variant-numeric: tabular-nums;
          text-align: center;
          color: $white;
          font-weight: 600;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          padding-top: 3px;
        }
      }

    }

    @media screen and (max-width: 500px) {
      padding-bottom: 20px;

      .v-tabs { display: none; }
      .mobile { display: block; }

      .actions {
        & > .flex { margin-left: 10px; }

        .counter,
        .logout {
          display: none;
        }

        .nav { order: 1; }

        .profile {
          order: 2;

          & > a { display: none; }
        }

        .menu_activator {
          position: relative;

          &.has_unread::after {
            content: '';
            position: absolute;
            top: 0;
            right: -6px;
            background-color: $error-color;
            height: 13px;
            width: 13px;
            border-radius: 50%;
          }
        }
      }
    }
  }

  ::v-deep .v-tabs {
    width: auto;
    overflow: auto;

    @media screen and (max-width: 1024px) {
      width: 100%;
      margin-left: 0;
    }

    &-slider {
      background: $orange !important;
      border-color: $orange !important;
      border-radius: 2px;
    }

    &-bar__content::after {
      height: 2px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      background: $light-theme-line !important;
      content: '';
    }

    .v-tab--active span {
      color: $orange !important;
      transition: all 0.3s $easing;
    }

    .v-tab {
      text-transform: none;
      color: $light-theme-text !important;
      font-size: 16px !important;
      font-weight: 600 !important;
      line-height: 20px;
      transition: all 0.3s $easing;
      letter-spacing: normal !important;

      @media screen and (max-width: 1024px) {
        margin-right: 0;
        font-size: 14px;
      }
      span { padding: 0 10px; }
    }
  }

  .v-menu__content {
    background: $white;
    border-radius: 10px !important;
    text-align: justify;
    padding: 12px 0;
    color: $blue;
    font-size: 16px;
    font-weight: 500;
    z-index: 12 !important;

    p {
      display: flex;
      justify-content: space-between;
      margin: 0 0 5px;
      padding: 0 16px;

      &:first-child {
        border-bottom: 1px solid $black-1;
        padding-bottom: 8px;
      }

      a {
        text-decoration: none;
        color: $blue;
      }

      span {
        display: inline-block;
        text-align: center;
        line-height: 1.7;
        color: $white;
        background-color: $error-color;
        font-size: 12px;
        border-radius: 10px;
        height: 20px;
        min-width: 20px;
        margin-left: 5px;
      }
    }
  }
</style>
